// extracted by mini-css-extract-plugin
export default {"contianer":"spinner_contianer__56X8H","spinner":"spinner_spinner__cxgf6","spin":"spinner_spin__Jcn2L","whiteborder":"spinner_whiteborder__bNIg5","medium":"spinner_medium__o1xRL"};